import { render } from "./PersonalDetailsForm.vue?vue&type=template&id=1cb67b23&scoped=true"
import script from "./PersonalDetailsForm.vue?vue&type=script&lang=js"
export * from "./PersonalDetailsForm.vue?vue&type=script&lang=js"

import "./PersonalDetailsForm.vue?vue&type=style&index=0&id=1cb67b23&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cb67b23"]])

export default __exports__